module.exports = __webpack_public_path__ + "img/ic-lock.f6499aa5.svg";